<template lang="pug">
    generic-upload-control.post-file-upload-control(v-bind='$attrs' :value='value' :uploadHandler='uploadHandler' @input='input' @remove='removed' ref='uploadControl')
</template>

<script>
import postFileService from '../../services/post-file-service'

export default {
    name: 'post-file-upload-control',
    props: {
        value: {
            type: Array,
        },
        group: {
            type: String,
        },
    },
    methods: {
        checkUploadActive() {
            return this.$refs.uploadControl.checkUploadActive()
        },

        uploadHandler(file, progressCb, updates, options, config) {
            options = {...options || {}, group: this.group, file, progressCb}
            if (options?.get) {
                return postFileService.get(file.id, options, config)
            }
            if (options?.update) {
                return postFileService.update(file.id, updates, options, config)
            }
            return postFileService.store(options)
        },

        input(...args) {
            this.$emit('input', ...args)
        },

        removed(...args) {
            this.$emit('remove', ...args)
        },

        uploadFile(...args) {
            this.$refs.uploadControl.uploadFile(...args)
        },

        async uploadVideoFileChanges(...args) {
            await this.$refs.uploadControl.uploadVideoFileChanges(...args)
        },

        clickDropzone(...args) {
            this.$refs.uploadControl.clickDropzone(...args)
        },

        setFiles(files) {
            this.$refs.uploadControl.setFiles(files)
        },
    },
}
</script>
